import React from "react";
import Table from "../../../components/Table";
import { OverlijdensRisicoVerzekering } from "../../../../../.generated/rapportage/rapportagetypes";
import { getOrvColumns } from "../../Producten/orv-kolommen";

export interface SingleOrvTableProps {
  data: OverlijdensRisicoVerzekering;
}

export interface OrvTableProps {
  data: OverlijdensRisicoVerzekering[];
}

export const SingleOrvTable: React.FC<SingleOrvTableProps> = ({
  data,
}: SingleOrvTableProps) => {
  return (
    <div className="mb-4">
      <Table
        columns={getOrvColumns({
          overlijdensrisicoverzekering: data,
          isHuidig: true,
        })}
        data={[data]}
        rotate={true}
        showHeader={true}
        filterNullAnd0Columns={true}
        id={`orv-table-${data.verzekeraar?.replace(/\s+/g, "-").toLowerCase() ||
          "orv"}`}
      />
    </div>
  );
};

export const OrvTable: React.FC<OrvTableProps> = ({ data }: OrvTableProps) => {
  return (
    <div className="orv-section">
      {data.map((orv, index) => (
        <SingleOrvTable key={index} data={orv} />
      ))}
    </div>
  );
};
